// const API_URL = location.href.split("#")[0];
const API_URL = "https://serviceportal.datavtech.com/";
export default API_URL;
